"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ANGAssetHighlightAdapter_instances, _ANGAssetHighlightAdapter_hit, _ANGAssetHighlightAdapter_highlight, _ANGAssetHighlightAdapter_latestHighlight, _ANGAssetHighlightAdapter_latestSource, _ANGAssetHighlightAdapter_searchTerm, _ANGAssetHighlightAdapter_getAssetNode, _ANGAssetHighlightAdapter_getCustomerMetadataNode, _ANGAssetHighlightAdapter_getCustomerMetadataSourceNode, _ANGAssetHighlightAdapter_getDocumentationNode, _ANGAssetHighlightAdapter_getVersionNode, _ANGAssetHighlightAdapter_getOrganizationNode, _ANGAssetHighlightAdapter_getUserNode, _ANGAssetHighlightAdapter_getHighlightedMetadata;
Object.defineProperty(exports, "__esModule", { value: true });
const keys_1 = require("../keys");
const utils_1 = require("../utils");
function removeHighlight(value) {
    return value.replace(/<em>(.*?)<\/em>/g, '$1');
}
class ANGAssetHighlightAdapter {
    constructor(hit) {
        _ANGAssetHighlightAdapter_instances.add(this);
        _ANGAssetHighlightAdapter_hit.set(this, void 0);
        _ANGAssetHighlightAdapter_highlight.set(this, void 0);
        _ANGAssetHighlightAdapter_latestHighlight.set(this, void 0);
        _ANGAssetHighlightAdapter_latestSource.set(this, void 0);
        _ANGAssetHighlightAdapter_searchTerm.set(this, void 0);
        const latest = (0, utils_1.getLatestHits)(hit);
        __classPrivateFieldSet(this, _ANGAssetHighlightAdapter_hit, hit, "f");
        __classPrivateFieldSet(this, _ANGAssetHighlightAdapter_highlight, hit[keys_1.HIGHLIGHT_KEY], "f");
        __classPrivateFieldSet(this, _ANGAssetHighlightAdapter_latestHighlight, latest[keys_1.HIGHLIGHT_KEY], "f");
        __classPrivateFieldSet(this, _ANGAssetHighlightAdapter_latestSource, latest[keys_1.SOURCE_KEY], "f");
        __classPrivateFieldSet(this, _ANGAssetHighlightAdapter_searchTerm, hit[keys_1.SEARCH_TERM_KEY], "f");
    }
    get latestHighlight() {
        return __classPrivateFieldGet(this, _ANGAssetHighlightAdapter_latestHighlight, "f");
    }
    get createdBy() {
        const userNode = __classPrivateFieldGet(this, _ANGAssetHighlightAdapter_instances, "m", _ANGAssetHighlightAdapter_getUserNode).call(this);
        const firstName = (0, utils_1.getProp)(userNode, 'firstName');
        const lastName = (0, utils_1.getProp)(userNode, 'lastName');
        if (firstName && lastName) {
            return `${firstName} ${lastName}`;
        }
        return null;
    }
    get scores() {
        return (0, utils_1.getScores)(__classPrivateFieldGet(this, _ANGAssetHighlightAdapter_hit, "f"));
    }
    get description() {
        return (0, utils_1.getProp)(__classPrivateFieldGet(this, _ANGAssetHighlightAdapter_instances, "m", _ANGAssetHighlightAdapter_getAssetNode).call(this), 'description');
    }
    get statuses() {
        const versionNode = __classPrivateFieldGet(this, _ANGAssetHighlightAdapter_instances, "m", _ANGAssetHighlightAdapter_getVersionNode).call(this);
        if (!versionNode) {
            return [];
        }
        return versionNode.status || [];
    }
    get labels() {
        const customerMetadataSource = __classPrivateFieldGet(this, _ANGAssetHighlightAdapter_instances, "m", _ANGAssetHighlightAdapter_getCustomerMetadataSourceNode).call(this);
        const customerMetadata = __classPrivateFieldGet(this, _ANGAssetHighlightAdapter_instances, "m", _ANGAssetHighlightAdapter_getCustomerMetadataNode).call(this);
        if (!customerMetadata || !customerMetadataSource) {
            return [];
        }
        const tags = customerMetadata.tags || [];
        const keyValueTags = (customerMetadataSource.keyValueTags || []).map((keyValueTag) => keyValueTag.split(':')[1]);
        const searchableValues = (customerMetadata.searchableValues || []).reduce((accum, current) => {
            const hasMatchingTag = keyValueTags.some((keyValueTag) => keyValueTag === removeHighlight(current));
            if (hasMatchingTag) {
                return [...accum, current];
            }
            return accum;
        }, []);
        return [...tags, ...searchableValues];
    }
    get categories() {
        const customerMetadataSource = __classPrivateFieldGet(this, _ANGAssetHighlightAdapter_instances, "m", _ANGAssetHighlightAdapter_getCustomerMetadataSourceNode).call(this);
        const customerMetadata = __classPrivateFieldGet(this, _ANGAssetHighlightAdapter_instances, "m", _ANGAssetHighlightAdapter_getCustomerMetadataNode).call(this);
        if (!customerMetadata || !customerMetadataSource) {
            return [];
        }
        return __classPrivateFieldGet(this, _ANGAssetHighlightAdapter_instances, "m", _ANGAssetHighlightAdapter_getHighlightedMetadata).call(this, customerMetadataSource.categories);
    }
    get fields() {
        const customerMetadataSource = __classPrivateFieldGet(this, _ANGAssetHighlightAdapter_instances, "m", _ANGAssetHighlightAdapter_getCustomerMetadataSourceNode).call(this);
        const customerMetadata = __classPrivateFieldGet(this, _ANGAssetHighlightAdapter_instances, "m", _ANGAssetHighlightAdapter_getCustomerMetadataNode).call(this);
        if (!customerMetadata || !customerMetadataSource) {
            return [];
        }
        return __classPrivateFieldGet(this, _ANGAssetHighlightAdapter_instances, "m", _ANGAssetHighlightAdapter_getHighlightedMetadata).call(this, customerMetadataSource.fields);
    }
    get pages() {
        const documentation = __classPrivateFieldGet(this, _ANGAssetHighlightAdapter_instances, "m", _ANGAssetHighlightAdapter_getDocumentationNode).call(this);
        if (!documentation) {
            return [];
        }
        return (documentation.content || []).map((content) => ({
            content
        }));
    }
    get versions() {
        const versionNode = __classPrivateFieldGet(this, _ANGAssetHighlightAdapter_instances, "m", _ANGAssetHighlightAdapter_getVersionNode).call(this);
        if (!versionNode) {
            return [];
        }
        return versionNode.semverVersion || [];
    }
    get name() {
        return (0, utils_1.getProp)(__classPrivateFieldGet(this, _ANGAssetHighlightAdapter_instances, "m", _ANGAssetHighlightAdapter_getAssetNode).call(this), 'name');
    }
    get organization() {
        return (0, utils_1.getProp)(__classPrivateFieldGet(this, _ANGAssetHighlightAdapter_instances, "m", _ANGAssetHighlightAdapter_getOrganizationNode).call(this), 'name');
    }
    parse() {
        return (0, utils_1.getInstanceProps)(this);
    }
}
_ANGAssetHighlightAdapter_hit = new WeakMap(), _ANGAssetHighlightAdapter_highlight = new WeakMap(), _ANGAssetHighlightAdapter_latestHighlight = new WeakMap(), _ANGAssetHighlightAdapter_latestSource = new WeakMap(), _ANGAssetHighlightAdapter_searchTerm = new WeakMap(), _ANGAssetHighlightAdapter_instances = new WeakSet(), _ANGAssetHighlightAdapter_getAssetNode = function _ANGAssetHighlightAdapter_getAssetNode() {
    return (0, utils_1.getANGHighlight)(__classPrivateFieldGet(this, _ANGAssetHighlightAdapter_highlight, "f"), 'assets', 'AssetNode');
}, _ANGAssetHighlightAdapter_getCustomerMetadataNode = function _ANGAssetHighlightAdapter_getCustomerMetadataNode() {
    return (0, utils_1.getANGHighlight)(__classPrivateFieldGet(this, _ANGAssetHighlightAdapter_latestHighlight, "f"), 'customer-metadata', 'CustomerMetadataNode');
}, _ANGAssetHighlightAdapter_getCustomerMetadataSourceNode = function _ANGAssetHighlightAdapter_getCustomerMetadataSourceNode() {
    return (0, utils_1.getANGNode)(__classPrivateFieldGet(this, _ANGAssetHighlightAdapter_latestSource, "f"), 'customer-metadata', 'CustomerMetadataNode');
}, _ANGAssetHighlightAdapter_getDocumentationNode = function _ANGAssetHighlightAdapter_getDocumentationNode() {
    return (0, utils_1.getANGHighlight)(__classPrivateFieldGet(this, _ANGAssetHighlightAdapter_latestHighlight, "f"), 'asset-documentation', 'DocumentationNode');
}, _ANGAssetHighlightAdapter_getVersionNode = function _ANGAssetHighlightAdapter_getVersionNode() {
    return (0, utils_1.getANGNode)(__classPrivateFieldGet(this, _ANGAssetHighlightAdapter_latestSource, "f"), 'asset-minor-versions', 'VersionNode');
}, _ANGAssetHighlightAdapter_getOrganizationNode = function _ANGAssetHighlightAdapter_getOrganizationNode() {
    return (0, utils_1.getANGHighlight)(__classPrivateFieldGet(this, _ANGAssetHighlightAdapter_highlight, "f"), 'organizations', 'OrganizationNode');
}, _ANGAssetHighlightAdapter_getUserNode = function _ANGAssetHighlightAdapter_getUserNode() {
    return (0, utils_1.getANGHighlight)(__classPrivateFieldGet(this, _ANGAssetHighlightAdapter_latestHighlight, "f"), 'users', 'UserNode');
}, _ANGAssetHighlightAdapter_getHighlightedMetadata = function _ANGAssetHighlightAdapter_getHighlightedMetadata(values) {
    const regex = new RegExp(`(${__classPrivateFieldGet(this, _ANGAssetHighlightAdapter_searchTerm, "f")
        .split(' ')
        .filter((value) => !!value)
        .join('|')})`, 'gi');
    const highlighted = (values !== null && values !== void 0 ? values : [])
        .filter((value) => value.search(regex) !== -1)
        .reduce((accum, current) => {
        var _a;
        const highlightedCurrent = current.replace(regex, `<em>$1</em>`);
        const [key, value] = highlightedCurrent.split(':');
        // eslint-disable-next-line no-param-reassign
        accum[key] = ((_a = accum[key]) !== null && _a !== void 0 ? _a : []).concat(value);
        return accum;
    }, {});
    return Object.keys(highlighted).map((key) => ({
        key,
        value: highlighted[key]
    }));
};
exports.default = ANGAssetHighlightAdapter;
